import { createStore, createLogger } from 'vuex'
import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import modules from './modules';

//数据持久化
import persistedState from 'vuex-persistedstate'
// 方式一
// const debug = import.meta.env.VITE_ENV !== 'production'
// 方式二（ 此方法需要在vite.config.js中配置，否则会报process is not defined ）
const debug = process.env.VITE_ENV !== 'production'

export const store = createStore({
	modules,
  	plugins: [
  		persistedState()
  	],
  	state,
  	mutations,
  	getters,
  	actions,
  	strict: debug,

})